import { queryOptions } from "@tanstack/react-query";
import {
  listAthleteQuestionnaire,
  listQuestionnaires,
  getQuestionnaire,
  listQuestionnaireSubmission,
  getSubmission,
  assignQuestionnaire,
  type Api,
} from "api-client";

import {
  type AthleteQuestionnaireSubmissions,
  type QuestionnairesRepository,
} from "./QuestionnairesRepository";
export function createPrivateQuestionnairesRepository(): QuestionnairesRepository {
  const queryKey = ["questionnaires", "private-athlete"];
  return {
    queryKey,
    listOptions(athleteId, pagination) {
      return queryOptions<Api.ListAthleteQuestionnaire.Output.Self>({
        queryKey: [...queryKey, athleteId, "list", pagination],
        async queryFn() {
          return (
            await listAthleteQuestionnaire({
              path: { athleteId },
              query: pagination,
            })
          ).data.data;
        },
      });
    },
    availableOptions(athleteId, query) {
      return queryOptions<Api.ListQuestionnaires.Output.Self>({
        queryKey: [...queryKey, athleteId, "available", query],
        async queryFn() {
          return (
            await listQuestionnaires({
              query: { query, excludeAthleteId: athleteId },
            })
          ).data.data;
        },
      });
    },
    submissionsOptions(athleteId, questionnaireId, pagination) {
      return queryOptions<AthleteQuestionnaireSubmissions>({
        queryKey: [
          ...queryKey,
          athleteId,
          questionnaireId,
          "submissions",
          pagination,
        ],
        async queryFn() {
          const [q, s] = await Promise.all([
            getQuestionnaire({ path: { id: questionnaireId } }),
            listQuestionnaireSubmission({
              path: { questionnaireId },
              query: { ...pagination, athleteId },
            }),
          ]);
          return {
            questionnaire: q.data.data.questionnaire,
            submissions: s.data.data,
          };
        },
      });
    },
    submissionOptions(athleteId, questionnaireId, submissionId) {
      return queryOptions<Api.GetSubmission.Output.Self>({
        queryKey: [
          ...queryKey,
          athleteId,
          questionnaireId,
          "submission",
          submissionId,
        ],
        async queryFn() {
          return (await getSubmission({ path: { submissionId } })).data.data;
        },
      });
    },
    assign(athleteId, questionnaireId) {
      return assignQuestionnaire({
        path: { questionnaireId },
        body: { athleteId },
      });
    },
  };
}
